import React from 'react';
import styles from './Projects.module.css';

const ProjectsFilters = ({ activeFilter, onFilterChange, filterCounts }) => {
  const filters = [
    { id: 'in_progress', label: 'In Progress', count: filterCounts.in_progress },
    { id: 'completed', label: 'Completed', count: filterCounts.completed },
    { id: 'all', label: 'All', count: filterCounts.all }
  ];

  return (
    <div className={styles.filtersSection}>
      <div className={styles.filterPills}>
        {filters.map(filter => (
          <button
            key={filter.id}
            className={`${styles.filterPill} ${
              activeFilter === filter.id ? styles.filterPillActive : ''
            }`}
            onClick={() => onFilterChange(filter.id)}
            type="button"
            aria-pressed={activeFilter === filter.id}
            aria-label={`Filter by ${filter.label}, ${filter.count} items`}
          >
            <span>{filter.label}</span>
            <span className={styles.filterCount}>{filter.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProjectsFilters;